import * as React from 'react';
import {
  Drawer,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import { Close, Menu as MenuIcon } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, IconButton } from 'components';
import { useNavigate } from 'react-router';
import { Subcategory } from '../CategoriesMenu/components/Subcategory/Subcategory';
import { CATEGORIES_MENU_CONFIG } from 'constants/categoriesMenu';
import { APP_ROUTES } from 'constants/routes';
import './MobileCategoriesDrawer.styled.scss';

export const MobileCategoriesDrawer = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = React.useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);
  const handleHomeClick = () => {
    navigate(APP_ROUTES.HOME);
    handleClose();
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        className="mobile-categories-drawer__trigger"
        color="primary"
        aria-label="open categories menu"
      >
        <MenuIcon fontSize="large" />
      </IconButton>

      <Drawer
        anchor="left"
        open={isOpen}
        onClose={handleClose}
        className="mobile-categories-drawer"
        PaperProps={{
          className: 'mobile-categories-drawer__paper',
        }}
      >
        <div className="mobile-categories-drawer__content">
          <div className="mobile-categories-drawer__header">
            <div className="mobile-categories-drawer__title-wrap">
              <MenuIcon />
              <h6>Categories</h6>
            </div>
            <IconButton
              onClick={handleClose}
              className="mobile-categories-drawer__close-button"
              aria-label="close categories"
            >
              <Close />
            </IconButton>
          </div>

          <div className="mobile-categories-drawer__body">
            {CATEGORIES_MENU_CONFIG.map((category) => (
              <Accordion
                key={category.id}
                className="mobile-categories-drawer__accordion"
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className="mobile-categories-drawer__accordion-summary"
                >
                  {category.displayName}
                </AccordionSummary>
                <AccordionDetails className="mobile-categories-drawer__accordion-details">
                  <Button
                    variant="text"
                    className="mobile-categories-drawer__category-link"
                    onClick={() => {
                      navigate(`/${category.id}`);
                      handleClose();
                    }}
                  >
                    View all {category.displayName}
                  </Button>
                  <Subcategory
                    subcategories={category.subCategories}
                    categoryId={category.id}
                    onCategoryClick={handleClose}
                  />
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
          <div className="mobile-categories-drawer__footer">
            <Button
              variant="outlined"
              fullWidth
              onClick={handleHomeClick}
              className="mobile-categories-drawer__home-button"
            >
              Go to Home
            </Button>
          </div>
        </div>
      </Drawer>
    </>
  );
};
